export const environment = {
  production: false,
  name: 'default',
  api: {
    baseUrl: 'http://localhost:8091',
    timeout: 30000
  },
  sso: {
    issuer: 'http://localsso:8443',
    clientId: 'localsso-client-id',
    redirectUri: 'http://localhost:8092'
  },
  features: {
    enableDebugLogging: true,
    enableAnalytics: false
  }
};